<template>
  <div
    class="notifications notifications--main align-items-center"
    :class="[{ 'in' : notifications }]"
  >
    <div
      v-for="(entry, index) in myNotifications"
      :key="`notification-${index}`"
      class="notification"
    >
      <strong v-html="entry.type"></strong>
      <div v-html="entry.message"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Notifications',
  computed: {
    ...mapState({
      notifications: state => state.layout.notifications,
      entries: state => state.notifications.entries,
    }),
    // @todo: implement this on API
    myNotifications() {
      return this.entries
        .filter(entry => entry.user_id === this.user._id)
        .sort(function(a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
    },
  },
  created() {
    this.$store.dispatch(`notifications/get`);
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.notifications--main {
  background-color: $inverse;
  border-left: 1px solid $muted;
  max-width: $sidebar-width;
  min-width: $sidebar-width;
  position: fixed;
  top: $header-height;
  bottom: 0;
  right: -1 * $sidebar-width;
  transition: ease-in-out left 0.3s;
  z-index: 1;
  &.in {
    right: 0;
  }
}

.notification {
  display: block;
  padding: 5px 10px;
  font-size: 12px;
  margin: 10px 5px;
  background-color: $muted;
}
</style>
